/**
 * $.uiCalendarInput() plugin.
 *
 * Options:
 *
 *  $date_first_input: jq object
 *  $date_second_input:  jq object|null (default: null)
 *
 *  month_first: string
 *  month_count: null|int (default: 6)
 *
 *  onDateFormat(that, ui_calendar): callback
 *  onCalendarInit(that, ui_calendar): callback
 *  onDateFirstInputHighlight(that): callback
 *  onDateSecondInputHighlight(that): callback
 *  onDaySelect(that): callback
 *  onFinish(that): callback
 */
(function ($) {
    var UICalendarInput = (function ($) {

        UICalendarInput = function (options) {
            var that = this;

            that.class = {
                drawer_calendar_input_wrapper: 'drawer-calendar-input-wrapper',
                
                calendar_input_wrapper: 'calendar-input-wrapper',
                calendar_input: 'calendar-input',
                calendar_input_dd: 'calendar-input-dd',

                focus: 'focus',
                highlight: 'highlight'
            };

            that.data_keys = {};

            // DOM
            that.$date_first_input = options['$date_first_input'];
            that.$date_second_input = options['$date_second_input'] || null;

            that.$wrapper = that.$date_first_input.parents('.' + that.class.calendar_input_wrapper);
            that.$calendar_wrapper = that.$wrapper.find('.' + that.class.calendar_input_dd);

            // CONST
            that.month_first = options['month_first'];
            that.month_count = options['month_count'] || 6;
            that.title = options['title'];
            that.show_bottom_button_ow = options['show_bottom_button_ow'] !== false;
            that.first_enabled_date = options['first_enabled_date'] || null;
            that.last_enabled_date = options['last_enabled_date'] || null;

            // HANDLERS
            that.onDateFormat = (options['onDateFormat'] || false);
            that.onCalendarInit = (options['onCalendarInit'] || function () {});
            that.onDateFirstInputHighlight = (options['onDateFirstInputHighlight'] || function () {});
            that.onDateSecondInputHighlight = (options['onDateSecondInputHighlight'] || function () {});
            that.onDaySelect = (options['onDaySelect'] || function () {});
            that.onFinish = (options['onFinish'] || function () {});

            // DYNAMIC VARS
            that.is_focused_second_input = false;
            that.ui_calendar = null;
            that.ui_calendar_drawer = null;

            // INIT
            that.init();
        };

        UICalendarInput.prototype.event_names = {
            open: 'calendar-open',
            close: 'calendar-close',
            change: 'calendar-change'
        };

        UICalendarInput.prototype.init = function () {
            var that = this;

            //
            that.__initHandlers();
        };

        UICalendarInput.prototype.finish = function () {
            var that = this;

            that.$wrapper.removeClass(that.class.focus);
            that.$wrapper.find('.' + that.class.highlight).removeClass(that.class.highlight);
            that.$calendar_wrapper.html('');
            that.ui_calendar = null;
            if (that.ui_calendar_drawer) {
                that.ui_calendar_drawer.close();
            }
            that.onFinish(that);
            that.$wrapper.trigger(that.event_names.close);
        };

        UICalendarInput.prototype.clearDateSecond = function () {
            var that = this;

            if (!that.$date_second_input || !that.$date_second_input.length) {
                return;
            }

            that.__setupDateInput(that.$date_second_input, null, true);
        };

        UICalendarInput.prototype.isDateFirstInputHighlighted = function () {
            var that = this;
            return that.isDateInputHighlighed(that.$date_first_input);
        };

        UICalendarInput.prototype.isDateSecondInputHighlighted = function () {
            var that = this;
            return that.isDateInputHighlighed(that.$date_second_input);
        };

        UICalendarInput.prototype.isDateInputHighlighed = function ($date_input) {
            var that = this;
            return $date_input.hasClass(that.class.highlight);
        };

        //

        UICalendarInput.prototype.initCalendar = function () {
            var that = this;
            
            that.__initCalendar();
        };

        /**
         * Возвращает текущие данные из календаря
         * @return {Array}
         * */
        UICalendarInput.prototype.getDates = function() {
            const that = this,
                  result = [];

            result.push(that.$date_first_input.data("value"));

            if (that.$date_second_input) {
                result.push(that.$date_second_input.data("value"));
            }

            return result;
        }

        UICalendarInput.prototype.setDates = function (dates, is_select) {
            var that = this;

            that.__setupDateInput(that.$date_first_input, dates[0], is_select);
            if (that.$date_second_input) {
                that.__setupDateInput(that.$date_second_input, dates[1] || null, is_select);
            }
        };

        UICalendarInput.prototype.__initCalendar = function () {
            var that = this,
                // These functions are needed to save the context <that>.
                onDayMouseenter = function ($day_wrapper, day_parsed, dates, is_date_second_primary, event) {
                    return that.__onCalendarDayMouseenter($day_wrapper, day_parsed, dates, is_date_second_primary, event);
                },
                onDayMouseleave = function ($day_wrapper, dates, is_date_second_primary, event) {
                    return that.__onCalendarDayMouseleave($day_wrapper, dates, is_date_second_primary, event);
                },
                onDaySelect = function ($day_wrapper, day_parsed, dates, is_date_second_primary, event) {
                    return that.__onCalendarDaySelect($day_wrapper, day_parsed, dates, is_date_second_primary, event);
                },
                onFinish = function (ui_calendar, dates) {
                    return that.__onCalendarFinish(ui_calendar, dates);
                },
                date_first = that.$date_first_input.data('value'),
                date_second = null;

            if (that.$date_second_input) {
                date_second = that.$date_second_input.data('value');
            }
            
            var calendar_options = {
                $wrapper: that.$calendar_wrapper,
                month_first: that.month_first,
                month_count: that.month_count,
                is_range: !!that.$date_second_input,
                date_first: date_first,
                date_second: date_second,
                is_date_second_primary: that.is_focused_second_input,
                show_calendar_type_select: false,
                show_bottom_button_ow: that.show_bottom_button_ow,
                show_bottom_notice: false,
                first_enabled_date: that.first_enabled_date,
                last_enabled_date: that.last_enabled_date,
                onDayMouseenter: onDayMouseenter,
                onDayMouseleave: onDayMouseleave,
                onDaySelect: onDaySelect,
                onFinish: onFinish,
            };
            
            if ($.sa.is_mobile() || $.sa.is_tablet()) {
                that.ui_calendar_drawer = $.uiDrawer({
                    position: 'bottom',
                    custom_class: that.class.drawer_calendar_input_wrapper,
                    disable_content_scroll: true,
                    mobile_fullscreen: true,
                    header_title: that.title,
                    content: '...',
                    onOpen: function ($drawer_wrapper, drawer) {
                        that.ui_calendar_drawer = drawer;
                        
                        calendar_options.$wrapper = $drawer_wrapper.find('.drawer-content');
                        calendar_options.is_drawer = true;
                        calendar_options.onRender = function () {
                            that.ui_calendar_drawer.setupContentHeight();
                        }
                        that.ui_calendar = $.uiCalendar(calendar_options);

                        setTimeout( function() {
                            that.$wrapper.trigger(that.event_names.open);
                        }, 0);
                    },
                    onResize: function ($drawer_wrapper, drawer) {
                        if (!$.sa.is_mobile() && !$.sa.is_tablet()) {
                            drawer.close();
                        }

                        if (that.ui_calendar) {
                            that.ui_calendar.setupScrollbarHeight();
                        }
                    },
                    onClose: function () {
                        that.ui_calendar_drawer = null;
                        that.finish();
                    }
                });
            } else {
                that.$wrapper.addClass(that.class.focus);
                that.ui_calendar = $.uiCalendar(calendar_options);
                setTimeout( function() {
                    that.$wrapper.trigger(that.event_names.open);    
                }, 0);
            }
            that.onCalendarInit(that, that.ui_calendar);
        };

        UICalendarInput.prototype.__onCalendarDayMouseenter = function ($day_wrapper, day, dates, is_date_second_primary, event) {
            var that = this;
            that.setDates(dates, false);
            //
            that.is_focused_second_input = is_date_second_primary;
            that.__highlightActualDateInput();
        };

        UICalendarInput.prototype.__onCalendarDayMouseleave = function ($day_wrapper, dates, is_date_second_primary, event) {
            var that = this;
            that.setDates(dates, false);
            //
            that.is_focused_second_input = is_date_second_primary;
            that.__highlightActualDateInput();
        };

        UICalendarInput.prototype.__onCalendarDaySelect = function ($day_wrapper, day, dates, is_date_second_primary, event) {
            var that = this;
            that.setDates(dates, true);
            that.onDaySelect(that); // Нужно для выбора даты в одну сторону
            
            //
            that.is_focused_second_input = is_date_second_primary;
            that.__highlightActualDateInput();
        };
        
        UICalendarInput.prototype.__highlightActualDateInput = function () {
            var that = this;

            if (that.is_focused_second_input) {
                that.$date_first_input.removeClass(that.class.highlight);
                if (that.$date_second_input) {
                    that.$date_second_input.addClass(that.class.highlight);
                }
                that.onDateSecondInputHighlight(that);
            } else {
                if (that.$date_second_input) {
                    that.$date_second_input.removeClass(that.class.highlight);
                }
                that.$date_first_input.addClass(that.class.highlight);
                that.onDateFirstInputHighlight(that);
            }
        };

        UICalendarInput.prototype.__onCalendarFinish = function (ui_calendar, dates) {
            var that = this;
            that.setDates(dates, true);
            that.finish();
        };

        UICalendarInput.prototype.__setupDateInput = function ($date_input, date, is_select) {
            var that = this,
                value = '',
                value_formatted = '';

            if (date) {
                var day_parsed = $.sa.parseDatetime(date);
                value = day_parsed.day.sql;
                if (typeof that.onDateFormat === 'function') {
                    value_formatted = that.onDateFormat(date, day_parsed);
                } else {
                    value_formatted = day_parsed.day.number + ' ' + day_parsed.month.name_short + ', ' + day_parsed.day.weekday_short;
                }
            }

            UIInput.prototype.setNotEmpty($date_input, !!value_formatted.length);
            $date_input.val(value_formatted.toLowerCase()).trigger(that.event_names.change);

            if (is_select) {
                $date_input
                    .attr('data-value', value)
                    .attr('value', value_formatted)
                    .data('value', value)
                    .trigger('change');
            }
        }

        //

        UICalendarInput.prototype.__initHandlers = function () {
            var that = this;

            that.__initDateInput(that.$date_first_input, false);
            if (that.$date_second_input) {
                that.__initDateInput(that.$date_second_input, true);
            }

            //
            that.__initCommonHandlers();
        };

        UICalendarInput.prototype.__initDateInput = function ($date_input, is_second) {
            var that = this;

            $date_input.on('focus', function (event) {
                that.is_focused_second_input = is_second;
                that.__highlightActualDateInput();

                if (!that.ui_calendar) {
                    that.__initCalendar();
                } else {
                    that.ui_calendar.setDateSecondIsPrimary(that.is_focused_second_input);
                }
            });
        };

        UICalendarInput.prototype.__initCommonHandlers = function () {
            const that = this;

            document.addEventListener('focus', function() {
                const is_inside = !!$(event.target).closest('.' + that.class.calendar_input).length;
                if (!is_inside) {
                    closeCalendar();
                }
            }, true);

            $.sa.$document.on('click', function(event) {
                const is_inside = !!$(event.target).closest('.' + that.class.calendar_input).length;
                if (!is_inside) {
                    closeCalendar();
                }
            });

            $.sa.$window.on('resize', function () {
                if (!$.sa.is_desktop()) {
                    closeCalendar();
                }
            });

            function closeCalendar() {
                if (!that.ui_calendar_drawer && that.ui_calendar) {
                    that.finish();
                }
            }
        };

        UICalendarInput.prototype.isFocused = function () {
            var that = this;
            return that.$wrapper.hasClass(that.class.focus);
        };

        return UICalendarInput;

    })($);

    $.uiCalendarInput = function (plugin_options) {
        plugin_options = (typeof plugin_options === 'object' ? plugin_options : {});
        var options = $.extend(true, {}, plugin_options);
        return new UICalendarInput(options);
    };
})(jQuery);